import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Heading = styled.span `
  font: var(--heading-six-font);
  color: var(--primary-darker);
  display: block;
`;
export const SubHeading = styled.span `
  font: var(--paragraph-font);
  color: white;
  display: block;
  margin-top: 2rem;
`;
export const Unit = styled.span `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 14rem;
`;
export const Price = styled.div `
  text-align: center;
`;
export default {
    Wrapper,
    Heading,
    SubHeading,
    Unit,
    Price,
};
